export function LoadingSkeleton({ lines = 4, blocks = 0, label = 'Loading' }: {
  lines?: number;
  blocks?: number;
  label?: string;
}) {
  return <div className="ux-skeleton" role="status" aria-label={label} aria-live="polite">
    {Array.from({ length: lines }, (_, index) => <span className="ux-skeleton-line" key={`line-${index}`} />)}
    {Array.from({ length: blocks }, (_, index) => <span className="ux-skeleton-block" key={`block-${index}`} />)}
  </div>;
}

export function PageLoadingSkeleton({ label }: { label: string }) {
  return <div className="ux-page-loading"><LoadingSkeleton lines={3} blocks={2} label={label} /></div>;
}
